const U = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600&auto=format`;
const Us = (id) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=1000&auto=format`;

export const IMG = {
  heroStudio: U('1612544409025-e1f6a56c1152'),
  mediaPhoto: U('1621024994278-e409544f4085'),
  mediaBts: U('1632187981988-40f3cbaeef5e'),
  mediaWeb: U('1765894359240-49b82f93b91a'),
  surf: U('1459745930869-b3d0d72c3cbb'),
  themePark: U('1621473909625-6a62ef5bedf7'),
  aquarium: U('1768847219343-bfdb1fecabfd'),
  printedAlbum: U('1595981234969-8259b94fde88'),
  photoJacket: U('1647782616311-ebd3b4eba507'),
  zoo1: U('1776127839712-6e89963df43e'),
  zoo2: U('1777210598486-20c549eab412'),
  water1: U('1695763905308-42a486c8478b'),
  water2: U('1696104282336-b9f5341c4a33'),
  adventure1: U('1768350329806-2fea7b97e142'),
  adventure3: U('1754347913962-f2364e351f62'),
  view1: U('1672927521329-a9cd17b972eb'),
  view2: U('1764936553462-99fb8c884b40'),
  marketing1: U('1758273706029-10b37f84f599'),
  marketing3: U('1683170139203-d8a41d680358'),
  video1: U('1535540878298-a155c6d065ef'),
  video2: U('1656230776385-c40b3ec3feb7'),
  video3: U('1710189966846-a94ce9b92736'),
  product: U('1471341971476-ae15ff5dd4ea'),
  fashion: U('1786096715663-f0ad4f0e9ff0'),
  lifestyle: U('1770062422860-92c107ef02cc'),
  web1: U('1606568156390-8f4edb5ef31f'),
  web2: U('1639452149139-57e72f28ce22'),
  web3: U('1707836885254-79b6e3d7b18d'),
  printed2: Us('1684741892637-c79b2e635921'),
  printed3: U('1613502073820-ffe3c3a3974f'),
  textureNeon: U('1614851099511-773084f6911d'),
  textureMetallic: U('1693648793394-0b76b7eb042e'),
};

export const VIDEO = {
  hero: '/assets/hero.mp4',
  souvenir: 'https://assets.mixkit.co/videos/preview/mixkit-people-riding-a-roller-coaster-41527-large.mp4',
  cinema: 'https://assets.mixkit.co/videos/preview/mixkit-close-up-of-a-camera-lens-41051-large.mp4',
};

export const MEDIA_SERVICE_IMAGES = ['/assets/service-1.webp', '/assets/service-2.webp', IMG.marketing1, IMG.web1];

export const VENUE_IMAGES = [
  '/assets/souvenir-track-1.webp', IMG.surf, IMG.themePark, IMG.zoo1, IMG.aquarium,
  IMG.water1, IMG.adventure1, IMG.view1, IMG.printed3,
];
